import { useEffect } from 'react'

const useOnMountEffect = (fn) => {
  useEffect(() => {
    fn()
  }, []) // eslint-disable-line
}

export default useOnMountEffect
